import React, { useState } from "react";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import Form from "./form";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { useDispatch, useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { openDialogAction } from "@icarius-common/dialog/actions";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

const DataItem = (props) => {
    const { data, detailList, activityList, materialsList, actionTypeList, momentList, setFormValue, closeNew } = props;

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);

    const isCreate = !Boolean(data);

    const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

    const handleDeletePublication = () => {
        if (isCreate) {
            closeNew();
        } else {
            const filteredItems = detailList.filter((el) => el.number !== data.number);
            setFormValue(
                filteredItems.map((item, index) => ({ ...item, number: index + 1 })),
                "details"
            );
        }
    };

    const handleClosePublication = () => {
        !isCreate && setIsOpen((prev) => !prev);
    };

    const handleOpenDeleteDialog = () => {
        dispatch(
            openDialogAction({
                title: getLocalizedString("atention"),
                msg: getLocalizedString("doYouWantToDeleteOnboardingStepForProfile"),
                onConfirm: handleDeletePublication,
            })
        );
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 10,
                    background: isOpen || isCreate ? color : "",
                    color: (isOpen || isCreate) && "white",
                }}
            >
                <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                    <Grid container item xs={1}>
                        {!isCreate && <DragIndicatorIcon />}
                    </Grid>
                    <Grid
                        container
                        item
                        xs={10}
                        style={{ cursor: !isCreate ? "pointer" : "" }}
                        onClick={handleClosePublication}
                    >
                        {isCreate ? (
                            <DataContainer lg={12} sm={12} md={12} text={getLocalizedString("stepCreation")} />
                        ) : (
                            <>
                                <DataContainer sm={12} md={1} lg={1} text={data.number} />
                                <DataContainer sm={12} md={4} lg={3} text={data.name} />
                                <DataContainer
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    text={momentList.find((item) => item.key === data.moment)?.value}
                                />
                                <DataContainer
                                    sm={12}
                                    md={5}
                                    lg={4}
                                    text={actionTypeList.find((item) => item.code === data.actionType)?.name}
                                />
                            </>
                        )}
                    </Grid>
                    <Grid container direction="row" item xs={1} justify="space-between">
                        <Tooltip title={getLocalizedString("delete")}>
                            <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>
            {isOpen && (
                <Form
                    data={data}
                    detailList={detailList}
                    activityList={activityList}
                    actionTypeList={actionTypeList}
                    momentList={momentList}
                    materialsList={materialsList}
                    setParentFormValue={setFormValue}
                    handleClose={isCreate ? closeNew : handleClosePublication}
                />
            )}
        </>
    );
};

export default DataItem;
